import { Mail, Phone } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { Reveal } from "@/components/site/Primitives";
import { ContactForm } from "@/components/site/ContactForm";
import { InstagramIcon } from "@/components/site/BrandIcons";
import { SITE } from "@/lib/site";

const CHANNELS = [
  { id: "phone", icon: Phone, label: "Phone", value: SITE.phoneDisplay, href: SITE.phoneHref },
  { id: "email", icon: Mail, label: "Email", value: SITE.email, href: `mailto:${SITE.email}` },
  { id: "instagram", icon: InstagramIcon, label: "Instagram", value: `@${SITE.instagram}`, href: SITE.instagramUrl, external: true },
];

export default function Contact() {
  return (
    <>
      <Seo
        title="Contact | Rhodes Private Transfers 24/7"
        description="Contact Alpha Transfer by phone, WhatsApp, email or Instagram. Private transfers and tours in Rhodes, available 24/7."
        path="/contact"
      />
      <section className="container-x pb-20 pt-28 md:pb-28 md:pt-36">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-gold-border bg-gold-light px-4 py-2 text-xs font-medium uppercase tracking-[0.2em] text-ink" data-testid="available-badge">
            <span className="h-2 w-2 animate-pulse rounded-full bg-emerald-500" /> Available 24/7
          </span>
          <h1 className="heading-xl mt-6 max-w-3xl text-ink">We would love to hear from you</h1>
          <p className="lead mt-6 max-w-xl">A question, a quote, a special request. Message us any time, day or night.</p>
        </Reveal>
        <div className="mt-14 grid gap-12 lg:grid-cols-12">
          <Reveal className="space-y-3 lg:col-span-5">
            {CHANNELS.map((c) => (
              <a
                key={c.id}
                href={c.href}
                target={c.external ? "_blank" : undefined}
                rel={c.external ? "noreferrer" : undefined}
                className="card-soft group flex items-center gap-5 border border-slate-200 p-5 transition-colors hover:border-gold"
                data-testid={`contact-channel-${c.id}`}
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-silver text-ink transition-colors group-hover:bg-gold group-hover:text-ink">
                  <c.icon className="h-5 w-5" />
                </span>
                <span>
                  <span className="block text-xs uppercase tracking-[0.2em] text-slate-500">{c.label}</span>
                  <span className="mt-1 block break-all text-lg text-ink">{c.value}</span>
                </span>
              </a>
            ))}
          </Reveal>
          <Reveal delay={0.1} className="card-soft border border-slate-200 bg-white p-6 md:p-10 lg:col-span-7">
            <h2 className="mb-8 font-serif text-3xl text-ink">Send us a message</h2>
            <ContactForm />
          </Reveal>
        </div>
      </section>
    </>
  );
}
